import React from 'react';
import './About.css';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero full-width-section">
        <div className="about-hero-full-width">
          <div className="section-container">
            <div className="about-hero-content">
              <h1 className="page-title">About Ambreen Daudpota</h1>
              <p className="page-subtitle">
                Dedicated legal professional committed to justice and excellence
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main About Content */}
      <section className="about-main full-width-section">
        <div className="section-container">
          <div className="about-content-grid">
            <div className="about-text">
              <h2 className="section-title">Professional Background</h2>
              <div className="title-underline"></div>
              <p className="about-description">
                Ambreen Daudpota is a distinguished Advocate of the High Court with extensive 
                experience in various areas of law. With a commitment to justice and a deep 
                understanding of the legal system, she has built a reputation for providing 
                exceptional legal representation and counsel to clients across diverse practice areas.
              </p>
              <p className="about-description">
                Her approach combines thorough legal knowledge with compassionate client service, 
                ensuring that each case receives the attention and expertise it deserves. She 
                believes in building strong attorney-client relationships based on trust, 
                transparency, and effective communication.
              </p>
              
              <div className="qualifications">
                <h3>Professional Qualifications</h3>
                <div className="qualification-list">
                  <div className="qualification-item">
                    <div className="qual-icon">🎓</div>
                    <div className="qual-content">
                      <h4>Law Degree</h4>
                      <p>Bachelor of Laws (LLB) from prestigious institution</p>
                    </div>
                  </div>
                  <div className="qualification-item">
                    <div className="qual-icon">⚖️</div>
                    <div className="qual-content">
                      <h4>High Court Advocate</h4>
                      <p>Licensed to practice before the High Court</p>
                    </div>
                  </div>
                  <div className="qualification-item">
                    <div className="qual-icon">📜</div>
                    <div className="qual-content">
                      <h4>Bar Association Member</h4>
                      <p>Active member of the local Bar Association</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="about-stats-card">
              <h3>Professional Achievements</h3>
              <div className="stats-list">
                <div className="stat-item">
                  <div className="stat-number">15+</div>
                  <div className="stat-label">Years of Experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Cases Successfully Handled</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">1000+</div>
                  <div className="stat-label">Satisfied Clients</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">95%</div>
                  <div className="stat-label">Success Rate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section full-width-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Core Values & Principles</h2>
            <p className="section-subtitle">
              The foundation of our legal practice
            </p>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon" style={{'--value-color': 'var(--accent-blue)'}}>
                🛡️
              </div>
              <h3>Integrity</h3>
              <p>Maintaining the highest ethical standards in all legal proceedings and client interactions.</p>
            </div>
            <div className="value-card">
              <div className="value-icon" style={{'--value-color': 'var(--accent-teal)'}}>
                🎯
              </div>
              <h3>Excellence</h3>
              <p>Striving for the best possible outcomes through thorough preparation and expert legal knowledge.</p>
            </div>
            <div className="value-card">
              <div className="value-icon" style={{'--value-color': 'var(--accent-purple)'}}>
                🤝
              </div>
              <h3>Dedication</h3>
              <p>Committed to providing personalized attention and unwavering support to every client.</p>
            </div>
            <div className="value-card">
              <div className="value-icon" style={{'--value-color': 'var(--accent-orange)'}}>
                ⚡
              </div>
              <h3>Efficiency</h3>
              <p>Delivering timely legal solutions while maintaining thoroughness and attention to detail.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Areas */}
      <section className="experience-section full-width-section">
        <div className="section-container">
          <div className="experience-content">
            <div className="experience-text">
              <h2 className="section-title">Areas of Expertise</h2>
              <div className="title-underline"></div>
              <p className="section-description">
                With years of practice in various legal domains, Ambreen Daudpota 
                brings comprehensive expertise to handle complex legal matters.
              </p>
              <div className="expertise-list">
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Civil and Commercial Litigation</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Criminal Defense and Prosecution</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Family and Matrimonial Law</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Property and Real Estate Law</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Corporate and Business Law</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Constitutional and Administrative Law</span>
                </div>
              </div>
              <div className="experience-cta">
                <Link to="/services" className="btn btn-primary">View Our Services</Link>
                <Link to="/contact" className="btn btn-outline">Schedule Consultation</Link>
              </div>
            </div>
            <div className="experience-visual">
              <div className="experience-card">
                <div className="card-header">
                  <h4>Professional Commitment</h4>
                </div>
                <div className="card-content">
                  <p>
                    "Every client deserves dedicated representation and personalized 
                    legal solutions. I am committed to fighting for justice and 
                    protecting the rights of those I represent."
                  </p>
                  <div className="quote-author">
                    <strong>- Ambreen Daudpota</strong>
                    <span>Advocate High Court</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
